export type CustomerDetailsHeaderTranslation = {
  button: {
    addContactInfo: string;
    addProcess: string;
    edit: string;
  };
  processRequiresApproval: string;
};

export const customerDetailsHeaderTranslation: CustomerDetailsHeaderTranslation = {
  button: {
    addContactInfo: 'Dodaj dane kontaktowe',
    addProcess: 'Utwórz process',
    edit: 'Edytuj',
  },
  processRequiresApproval:
    'Wymaga zatwierdzenia. Proces można utworzyć tylko dla aktywnego, zatwierdzonego klienta.',
};
